(function($) {


  function checkStrength(password) {
    //initial strength
    var strength = 0

    //if the password length is less than 6, return message.
    if (password.length < 6) return 0

    //length is ok, lets continue.
    //if length is 8 characters or more, increase strength value
    if (password.length > 7) strength += 1;

    //if password contains both lower and uppercase characters, increase strength value
    if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) strength += 1;

    //if it has numbers and characters, increase strength value
    if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)) strength += 1;

    //if it has one special character, increase strength value
    if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1;

    //if it has two special characters, increase strength value
    if (password.match(/(.*[!,%,&,@,#,$,^,*,?,_,~].*[!,",%,&,@,#,$,^,*,?,_,~])/)) strength += 1;

    return strength;

  }

  $.validator.addMethod('is_password', function(value, element) {

    if (!$(element).hasClass('required') && value == '') return true;

    var strength = checkStrength(value);

    console.log(strength)

    if (strength < 2 ) {
      $(element).removeClass();
      $(element).addClass('weak');
      return false

    } else if (strength == 2 ) {
      $(element).removeClass();
      $(element).addClass('good');

    } else {
      $(element).removeClass();
      $(element).addClass('strong');
    }

    return true;

  }, "La contraseña debe tener más de 6 caracteres y tener dígitos y caracteres");

})(jQuery);



